import React, { ReactNode } from 'react';

import classNames from 'classnames';
import { ChevronDownIcon } from '@ergeon/icons/hero/mini';

type MobileDisclosureProps = {
  children: ReactNode;
  className?: string;
  count: string;
  title: string;
};

const SUMMARY_CLASSES = classNames(
  'flex cursor-pointer list-none items-center justify-between gap-3 rounded-xl px-4 py-3 paragraph-2',
  'focus:outline-hidden focus-visible:ring-2 focus-visible:ring-blue-500 dark:focus-visible:ring-blue-300',
);

const MobileDisclosure = ({ children, className, count, title }: MobileDisclosureProps) => (
  <details
    className={classNames('group rounded-xl border border-gray-300 dark:border-gray-700', className)}>
    <summary className={SUMMARY_CLASSES}>
      <span className="font-medium text-gray-900 dark:text-white">{title}</span>
      <span className="flex items-center gap-1 text-gray-600 dark:text-gray-400">
        {count}
        <ChevronDownIcon aria-hidden="true" className="size-4 transition-transform group-open:rotate-180" />
      </span>
    </summary>
    <div className="border-t border-gray-200 p-3 dark:border-gray-700">{children}</div>
  </details>
);

export default MobileDisclosure;
